import { render, staticRenderFns } from "./CallLogPage.vue?vue&type=template&id=25558dd6"
import script from "./CallLogPage.vue?vue&type=script&lang=js"
export * from "./CallLogPage.vue?vue&type=script&lang=js"
import style0 from "./CallLogPage.vue?vue&type=style&index=0&id=25558dd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports